import { FunctionComponent } from "react";

import { Typography } from "@digital-services/ui";

import AccountMenu from "@account/components/AccountMenu";

import { useUserContext } from "@hooks/useUserContext";

const UserProfile: FunctionComponent = () => {
  const { user } = useUserContext();

  return (
    <div
      className="profile-section relative flex flex-col"
      data-testid="user-profile"
    >
      <Typography
        variant="smallTitle"
        className="text-black-500 pr-10 text-right"
        data-testid="user-name"
      >
        {user.name}
      </Typography>
      <AccountMenu />
    </div>
  );
};

export default UserProfile;
